module.exports = __webpack_public_path__ + "static/img/eicad_icon.8b932468.png";